export default __webpack_public_path__ + "static/media/serie2.c7af2f5c.png";